import * as types from '../actions/ActionTypes';

const reportInitialState = {
    loading: false,
    data: [],
    headers: [],
    error: null,
};

const initialState = {
    dailyTotal: { ...reportInitialState },
    queueReport: { ...reportInitialState },
    monthlyTotal: { ...reportInitialState },
    totalDashboard: { ...reportInitialState },
    jobLogs: { ...reportInitialState },
    jobLogDetails: { ...reportInitialState },
};

const ACDReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_ACD_JOB_LOGS:
            return {
                ...state,
                jobLogs: {
                    ...state.jobLogs,
                    loading: true,
                },
            };
        case types.FETCH_ACD_JOB_LOGS_SUCCESS:
            return {
                ...state,
                jobLogs: {
                    ...state.jobLogs,
                    loading: false,
                    data: action.payload.data,
                    error: null,
                },
            };
        case types.FETCH_ACD_JOB_LOGS_FAILURE:
            return {
                ...state,
                jobLogs: {
                    ...state.jobLogs,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.FETCH_ACD_JOB_LOG_DETAILS:
            return {
                ...state,
                jobLogDetails: {
                    ...state.jobLogDetails,
                    loading: true,
                },
            };
        case types.FETCH_ACD_JOB_LOG_DETAILS_SUCCESS:
            return {
                ...state,
                jobLogDetails: {
                    ...state.jobLogDetails,
                    loading: false,
                    data: action.payload,
                    error: null,
                },
            };
        case types.FETCH_ACD_JOB_LOG_DETAILS_FAILURE:
            return {
                ...state,
                jobLogDetails: {
                    ...state.jobLogDetails,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.FETCH_ACD_DAILY_TOTAL_REPORT:
            return {
                ...state,
                dailyTotal: {
                    ...state.dailyTotal,
                    loading: true,
                },
            };
        case types.FETCH_ACD_DAILY_TOTAL_REPORT_SUCCESS:
            return {
                ...state,
                dailyTotal: {
                    ...state.dailyTotal,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.FETCH_ACD_DAILY_TOTAL_REPORT_FAILURE:
            return {
                ...state,
                dailyTotal: {
                    ...state.dailyTotal,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.FETCH_ACD_DAILY_QUEUE_REPORT:
            return {
                ...state,
                queueReport: {
                    ...state.queueReport,
                    loading: true,
                },
            };
        case types.FETCH_ACD_DAILY_QUEUE_REPORT_SUCCESS:
            return {
                ...state,
                queueReport: {
                    ...state.queueReport,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.FETCH_ACD_DAILY_QUEUE_REPORT_FAILURE:
            return {
                ...state,
                queueReport: {
                    ...state.queueReport,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.FETCH_ACD_MONTHLY_TOTAL_REPORT:
            return {
                ...state,
                monthlyTotal: {
                    ...state.monthlyTotal,
                    loading: true,
                },
            };
        case types.FETCH_ACD_MONTHLY_TOTAL_REPORT_SUCCESS:
            return {
                ...state,
                monthlyTotal: {
                    ...state.monthlyTotal,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.FETCH_ACD_MONTHLY_TOTAL_REPORT_FAILURE:
            return {
                ...state,
                monthlyTotal: {
                    ...state.monthlyTotal,
                    loading: false,
                    error: action.payload,
                },
            };
        case types.FETCH_ACD_TOTAL_DASHBOARD_REPORT:
            return {
                ...state,
                totalDashboard: {
                    ...state.totalDashboard,
                    loading: true,
                },
            };
        case types.FETCH_ACD_TOTAL_DASHBOARD_REPORT_SUCCESS:
            return {
                ...state,
                totalDashboard: {
                    ...state.totalDashboard,
                    loading: false,
                    data: action.payload.data,
                    headers: action.payload.headers,
                    error: null,
                },
            };
        case types.FETCH_ACD_TOTAL_DASHBOARD_REPORT_FAILURE:
            return {
                ...state,
                totalDashboard: {
                    ...state.totalDashboard,
                    loading: false,
                    error: action.payload,
                },
            };
        default:
            return state;
    }
};

export default ACDReportReducer;